﻿// --- START OF FILE Performance.jsx ---

import React from 'react';
import { motion } from 'framer-motion';
import { HardDrive, Repeat, DollarSign, Award } from 'lucide-react';

const Performance = () => {
  const impactMetrics = [
    {
      icon: HardDrive,
      value: '200+',
      label: 'Devices Managed',
      description: 'Across global data centers',
      color: 'from-[hsl(var(--primary-gold))] to-[hsl(var(--accent-cyan))]' // Gold to Accent Cyan
    },
    {
      icon: Repeat,
      value: '100+',
      label: 'Infrastructure Migrations',
      description: 'Executed with minimal downtime',
      color: 'from-[hsl(var(--aztec-dark))] to-[hsl(var(--accent-violet))]' // Aztec Dark to Elegant Violet
    },
    {
      icon: DollarSign,
      value: '$5M+',
      label: 'Cost Savings Identified',
      description: 'Through strategic audits',
      color: 'from-[hsl(var(--primary-gold))] to-[hsl(var(--aztec-dark))]' // Gold to Aztec Dark
    },
    {
      icon: Award,
      value: 'Top-Tier',
      label: 'Project Experience',
      color: 'from-[hsl(var(--accent-violet))] to-[hsl(var(--primary-gold))]' // Elegant Violet to Gold
    }
  ];

  return (
    <section id="performance" className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[hsl(var(--accent-violet))]/5 to-transparent"></div> {/* Use accent-violet for background tint */}
      
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="gradient-text">Proven Impact</span> {/* Now uses Oxanium font */}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Metrics from projects led for top-tier financial institutions, showcasing a track record of excellence and tangible results.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {impactMetrics.map((metric, index) => (
            <motion.div
              key={metric.label}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, y: -10 }}
              className="glass-effect rounded-xl p-8 text-center group hover:neon-glow transition-all duration-300"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${metric.color} rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <metric.icon className="w-8 h-8 text-white" />
              </div>
              <div className="text-4xl font-bold gradient-text mb-2">{metric.value}</div> {/* Now uses Oxanium font */}
              <div className="text-xl font-semibold text-white mb-3">{metric.label}</div>
              <div className="text-gray-400 text-sm">{metric.description}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>


  );
};

export default Performance;
// --- END OF FILE Performance.jsx ---